'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function pad(str, length) {
    var chars = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ' ';
    return str.padStart(Math.floor((length - str.length) / 2) + str.length, chars).padEnd(length, chars);
}
exports.pad = pad;
